import { Component, OnInit, Inject, QueryList, ViewChildren, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { Router } from '@angular/router';
import { ProductService } from '@app/shared/services/product/product.service';
import { CustomProductImageInterface, UploadProductImagesInterface } from '@app/shared/services/product/uploadProductImages.interface';
import { ImageCroppedEvent } from 'ngx-image-cropper';


@Component({
  selector: 'app-upload-product-image-dialog',
  templateUrl: './upload-product-image-dialog.component.html',
  styleUrls: ['./upload-product-image-dialog.component.css']
})

export class UploadProductImageDialogComponent implements OnInit {
  ProductId: Number;
  DesignId: Number;
  images: CustomProductImageInterface[] = [];
  deletedImages: Number[] = [];
  uploadForm: FormGroup;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  cropperReady = false;
  imageCount = 0;
  isSomeAction = false;
  idForEdit = 0;
  styleId: number;
  @ViewChild('inputImage') inputImageVariable!: any;
  @ViewChild('inputImageEdit') inputImageVariableEdit!: any;

  constructor(public dialogRef: MatDialogRef<UploadProductImageDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private loaderService: LoaderService, private notificationService: NotificationService,
    private router: Router, private errorhandlerService: ErrorhandlerService,
    private productService: ProductService, private fb: FormBuilder) {
    this.uploadForm = this.fb.group({
      file: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.ProductId = this.data.productId;
    this.DesignId = this.data.designId;
    this.data.imageList.forEach(val => this.images.push(Object.assign({}, val)));
    //this.images = this.data.imageList;
    this.imageCount = this.images.length;
    this.styleId = this.data.styleId;
  }

  onclose(): void {
    this.dialogRef.close();
  }
  fn_OnFileChange(event, isAdd: boolean) {
    if (event.target.files && event.target.files[0]) {
      // var filesAmount = event.target.files.length;
      // for (let i = 0; i < filesAmount; i++) {
      //         var reader = new FileReader();

      //         reader.onload = (event:any) => {

      //            this.images.push(event.target.result); 

      //            this.uploadForm.patchValue({
      //               fileSource: this.images
      //            });
      //         }

      //         reader.readAsDataURL(event.target.files[i]);
      // }
      if (isAdd) {
        this.idForEdit = 0;
      }

      if (this.imageCount >= 6 && isAdd == true) {
        this.notificationService.info('Only 6 Iamges are allowed', 'Maximum Image Reached');
      }
      else {
        let file = event.target.files[0];
        const name = file.name;
        const type = file.type;
        const size = file.size;
        if (type !== 'image/jpeg' && type !== 'image/jpg' && type !== 'image/png') {
          this.inputImageVariable.nativeElement.value = '';
          this.inputImageVariableEdit.nativeElement.value = '';
          this.notificationService.info('Invalid type file', 'Type');
          return;
        }
        if (Math.round(size / 1024) >= 10048) {
          this.inputImageVariable.nativeElement.value = '';
          this.inputImageVariableEdit.nativeElement.value = '';
          this.notificationService.info('Size must be less than 10 Mb', 'Size');
          return;
        } else {
          this.imageChangedEvent = event;
        }
      }
    }
  }

  imageCroppedBase64(image: string) {
    this.croppedImage = image;
    //this.data = image;
  }

  imageCropped(image: ImageCroppedEvent) {
    if (image.base64) {
      this.croppedImage = image.base64;
    } else if (image.blob) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.croppedImage =
          reader.result as string;
      };
      reader.readAsDataURL(image.blob);
    }
  }
  imageLoaded() {
    this.cropperReady = true;
  }
  loadImageFailed() {
    console.log('Load failed');
  }

  fn_AddImage() {
    if (this.croppedImage != '') {
      if (this.idForEdit > 0) {
        let existObj = this.images.find(i => i.Id == this.idForEdit);
        let productImageEdit: CustomProductImageInterface = {
          Id: this.idForEdit,
          Image: this.croppedImage,
          IsAdded: false,
          IsEdited: true,
          IsActive: true,
          IsDefault: false,
          IsCustom: true,
          StyleId: existObj.StyleId,
          UniqueStyleId: existObj.UniqueStyleId
        };
        let index = this.images.findIndex(i => i.Id == this.idForEdit);
        this.images[index] = productImageEdit;
      }
      else {
        let productImage: CustomProductImageInterface = {
          Id: 0,
          Image: this.croppedImage,
          IsAdded: true,
          IsEdited: false,
          IsActive: true,
          IsDefault: false,          
          IsCustom: true,
          StyleId: 0,
          UniqueStyleId: 0
        };
        this.images.push(productImage);

        this.imageCount++;
      }
    }

    this.inputImageVariable.nativeElement.value = '';
    this.inputImageVariableEdit.nativeElement.value = '';
    this.cropperReady = false;
    this.croppedImage = '';
    this.isSomeAction = true;
  }
  fn_CancelCrop() {
    this.inputImageVariable.nativeElement.value = '';
    this.inputImageVariableEdit.nativeElement.value = '';
    this.cropperReady = false;
    this.croppedImage = '';
  }
  fn_DeleteImage(index: any, Id: number) {
    this.images.splice(index, 1);
    this.imageCount--;

    if (+Id > 0) {
      this.deletedImages.push(Id);
      this.isSomeAction = true;
    }
  }
  fn_EditImage(index: any, Id: number) {
    this.idForEdit = Id;
    this.isSomeAction = true;
  }

  fn_UploadFormSubmit(form: FormGroup) {
    let uploadImageModel: UploadProductImagesInterface = {
      ProductId: Number(this.ProductId),
      DesignId: Number(this.DesignId),
      Images: this.images,
      DeletedImages: this.deletedImages,
      StyleId: this.styleId
    };
    this.loaderService.show();
    this.productService.uploadProductImages(uploadImageModel).subscribe((res: any) => {
      if (res.StatusCode === 200) {
        this.notificationService.success(res.Message, 'Images uploaded');
        this.dialogRef.close(true);
        this.data= true;
      }
      this.loaderService.hide();
    }, (err: any) => {
      this.loaderService.hide();
      // this.notificationService.error('An error occured', 'Error');
      this.errorhandlerService.handleError(err);
    });
  }

  fn_MakeImageActive(event, index: any){  
    let checked = event.checked;
    if(checked == false){
      var activeImages = this.images.filter(x=> x.IsActive);
      if(activeImages != undefined && activeImages.length <= 1){        
        return false;
      }
    }
    let item = this.images[index];
    item.IsActive = checked;
    this.isSomeAction = true;
    return true;
  }
  fn_CheckLeastActive(event, index: any){    
    let checked = !event.currentTarget.getElementsByTagName('input')[0].checked;
    if(checked == false){
      var activeImages = this.images.filter(x=> x.IsActive);
      if(activeImages != undefined && activeImages.length <= 1){        
        this.notificationService.info('There should be at least 1 Active Image.', 'Maximum In-Active Reached');
        event.preventDefault();
        return false;
      }
    }
  }
}
